"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pomezia": {
    "f6250947": [{
      "hkey": "e7fbfc0d",
      "slug": "santa-procula-cinque-poderi",
      "name": "Santa Procula-Cinque Poderi",
      "primary": true,
      "skipSearch": false
    }],
    "santa-procula": [{
      "hkey": "e7fbfc0d",
      "slug": "santa-procula-cinque-poderi",
      "name": "Santa Procula-Cinque Poderi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0e877406": [{
      "hkey": "5ff91369",
      "slug": "sedici-pini-colli-di-enea",
      "name": "Sedici Pini-Colli di Enea",
      "primary": true,
      "skipSearch": false
    }],
    "pomezia-castagneto-colli-di-enea": [{
      "hkey": "5ff91369",
      "slug": "sedici-pini-colli-di-enea",
      "name": "Sedici Pini-Colli di Enea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "91eee795": [{
      "hkey": "65f983bf",
      "slug": "torvaianica",
      "name": "Torvaianica",
      "primary": true,
      "skipSearch": false
    }],
    "torvajanica": [{
      "hkey": "65f983bf",
      "slug": "torvaianica",
      "name": "Torvaianica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "067bc9e5": [{
      "hkey": "b3dbca73",
      "slug": "torvaianica-alta",
      "name": "Torvaianica Alta",
      "primary": true,
      "skipSearch": false
    }],
    "torvajanica-alta": [{
      "hkey": "b3dbca73",
      "slug": "torvaianica-alta",
      "name": "Torvaianica Alta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;